import uuid from 'uuid/v1';
import Amplify, { Auth } from 'aws-amplify';
import S3 from 'aws-sdk/clients/s3'; // Importe o S3 da v2
import config from '../config/aws';

// Helper para obter a extensão, pode manter a sua.
function ext(filename) {
  return filename.split('.').pop();
}

export async function fileUploadMedia(fileType, fileId, file, fncProgress) {
  // 1. Obtenha as credenciais do Amplify
  const credentials = await Auth.currentCredentials();

  // 2. Configure o cliente S3 do SDK v2 com essas credenciais
  const s3 = new S3({
    region: config.S3_MEDIA_FILM.REGION, // Sua região
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${Date.now()}.${ext(file.name)}`;
  const bucket = fileType === 'film' ? config.S3_MEDIA_FILM.BUCKET : config.S3_MUSIC.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/'+filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    // 3. Use o managed uploader da v2, que faz multipart upload automaticamente
    const managedUpload = s3.upload(params);

    // 4. Monitore o progresso
    managedUpload.on('httpUploadProgress', (progress) => {
      const percent = Math.round((progress.loaded * 100) / progress.total);
      console.log(`Uploaded: ${percent}%`);
      fncProgress(percent);
    });

    // 5. Espere a conclusão
    const result = await managedUpload.promise();
    console.log('Upload concluído com sucesso!', result.Location);

    // Construa seu link final
    let link = `${fileType === 'film' ? config.S3_MEDIA_FILM.CLOUD_FRONT : config.S3_MUSIC.CLOUD_FRONT}/`;
    link += filename;

    return { key: result.Key, filename, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export async function fileUploadImg(fileType, fileId, fileSize, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config[`S3_THUMBNAILS_${fileType.toUpperCase()}`].REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileSize}---${Date.now()}.${ext(file.name)}`;
  const bucket = config[`S3_THUMBNAILS_${fileType.toUpperCase()}`].BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    // Link CDN
    const link = `https://cdn.${fileType.toLowerCase()}.alivethenetwork.tv/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadInfluencerImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_INFLUENCER.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_INFLUENCER.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadCatalogImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_CATALOG.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_CATALOG.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadCategoryImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_CATEGORY.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_CATEGORY.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadLabelImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_LABEL.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_LABEL.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadArtistImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_ARTIST.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_ARTIST.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadAlbumImg(fileId, fileType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: config.S3_THUMBNAILS_ALBUM.REGION,
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_ALBUM.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadSong(fileId, fileType, file, fncProgress) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1', // Ajuste conforme necessário
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_SONG.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const managedUpload = s3.upload(params);

    managedUpload.on('httpUploadProgress', (progress) => {
      console.log(`# Uploaded: ${progress.loaded}/${progress.total}`);
      const varControl = (progress.loaded * 100) / progress.total;
      const strControl = varControl.toFixed(2);
      console.log(`# Uploaded: ${strControl} %`);
      fncProgress(parseFloat(strControl));
    });

    const result = await managedUpload.promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function s3Upload(file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1', // Ajuste conforme necessário
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${Date.now()}-${uuid()}`;

  const params = {
    Bucket: config.S3_THUMBNAILS_PROFILE.BUCKET, // Ajuste o bucket conforme necessário
    Key: filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result);

    return result.Key;
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}
export async function fileRead(key) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const params = {
    Bucket: config.S3_THUMBNAILS_PROFILE.BUCKET, // Ajuste o bucket conforme necessário
    Key: key,
    Expires: 900, // URL válida por 15 minutos
  };

  try {
    const url = s3.getSignedUrl('getObject', params);
    return url;
  } catch (error) {
    console.error('Erro ao gerar URL assinada:', error);
    throw error;
  }
}

export async function fileUploadMediaImg(medId, medType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${medId}---${medType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAIL.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadMediaImgRead(key) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const params = {
    Bucket: config.S3_THUMBNAIL.BUCKET,
    Key: key,
    Expires: 900, // URL válida por 15 minutos
  };

  try {
    const url = s3.getSignedUrl('getObject', params);
    return url;
  } catch (error) {
    console.error('Erro ao gerar URL assinada:', error);
    throw error;
  }
}

export async function fileUploadMediaMovie(chaId, medId, file, fncProgress) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${chaId}---${medId}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_MOVIE.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const managedUpload = s3.upload(params);

    managedUpload.on('httpUploadProgress', (progress) => {
      console.log(`# Uploaded: ${progress.loaded}/${progress.total}`);
      const varControl = (progress.loaded * 100) / progress.total;
      const strControl = varControl.toFixed(2);
      console.log(`# Uploaded: ${strControl} %`);
      fncProgress(parseFloat(strControl));
    });

    const result = await managedUpload.promise();
    console.log('Upload concluído com sucesso!', result.Location);

    return { key: result.Key, filename };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadMediaMovieRead(key) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const params = {
    Bucket: config.S3_MOVIE.BUCKET,
    Key: key,
    Expires: 900, // URL válida por 15 minutos
  };

  try {
    const url = s3.getSignedUrl('getObject', params);
    return url;
  } catch (error) {
    console.error('Erro ao gerar URL assinada:', error);
    throw error;
  }
}

export async function fileUploadChannelImg(chaId, medType, file) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const filename = `${chaId}---${medType}---${Date.now()}.${ext(file.name)}`;
  const bucket = config.S3_THUMBNAILS_PROFILES.BUCKET;

  const params = {
    Bucket: bucket,
    Key: 'public/' + filename,
    Body: file,
    ContentType: file.type,
  };

  try {
    const result = await s3.upload(params).promise();
    console.log('Upload concluído com sucesso!', result.Location);

    const link = `https://${bucket}.s3.amazonaws.com/public/${filename}`;

    return { key: result.Key, link };
  } catch (error) {
    console.error('Erro no upload com SDK v2:', error);
    throw error;
  }
}

export async function fileUploadChannelImgRead(key) {
  const credentials = await Auth.currentCredentials();

  const s3 = new S3({
    region: 'us-east-1',
    credentials: Auth.essentialCredentials(credentials),
  });

  const params = {
    Bucket: config.S3_THUMBNAILS_PROFILES.BUCKET,
    Key: key,
    Expires: 900, // URL válida por 15 minutos
  };

  try {
    const url = s3.getSignedUrl('getObject', params);
    return url;
  } catch (error) {
    console.error('Erro ao gerar URL assinada:', error);
    throw error;
  }
}


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// melhor mas precisa atualizar react
// import uuid from 'uuid/v1';
// import { Auth } from 'aws-amplify';
// import {
//   S3Client,
//   CreateMultipartUploadCommand,
//   UploadPartCommand,
//   CompleteMultipartUploadCommand,
//   AbortMultipartUploadCommand,
// } from '@aws-sdk/client-s3';
// import config from '../config/aws';

// // Helper para obter a extensão, pode manter a sua.
// function ext(filename) {
//   return filename.split('.').pop();
// }

// export async function fileUploadMedia(fileType, fileId, file, fncProgress) {

//   // 1. --- Configuração Inicial ---
//   const filename = `${fileId}---${Date.now()}.${ext(file.name)}`;
//   const bucket = fileType === 'film' ? config.S3_MEDIA_FILM.BUCKET : config.S3_MUSIC.BUCKET;

//   // O tamanho da parte é crucial. 10MB é um bom começo.
//   // O S3 exige que as partes tenham no mínimo 5MB (exceto a última).
//   const chunkSize = 10 * 1024 * 1024; // 10MB
//   const totalChunks = Math.ceil(file.size / chunkSize);

//   // 2. --- Obter Credenciais e Criar Cliente S3 ---
//   // Obtém as credenciais iniciais. Elas serão renovadas para cada parte se necessário.
//   const credentials = await Auth.currentCredentials();
//   const s3Client = new S3Client({
//     region: config.S3_MEDIA_FILM.REGION, // ou sua região
//     credentials: {
//       accessKeyId: credentials.accessKeyId,
//       secretAccessKey: credentials.secretAccessKey,
//       sessionToken: credentials.sessionToken,
//     },
//   });

//   let uploadId;

//   try {
//     // 3. --- Iniciar o Multipart Upload ---
//     console.log('Iniciando Multipart Upload...');
//     const createUploadParams = {
//       Bucket: bucket,
//       Key: filename,
//       ContentType: file.type,
//     };
//     const multipartUpload = await s3Client.send(new CreateMultipartUploadCommand(createUploadParams));
//     uploadId = multipartUpload.UploadId;
//     console.log(`Upload ID: ${uploadId}`);

//     // 4. --- Fazer Upload de Cada Parte ---
//     const uploadedParts = [];
//     for (let i = 0; i < totalChunks; i++) {
//       const start = i * chunkSize;
//       const end = start + chunkSize;
//       const chunk = file.slice(start, end);
//       const partNumber = i + 1;

//       console.log(`Fazendo upload da parte ${partNumber}/${totalChunks}`);

//       // O SDK renova as credenciais automaticamente se expirarem entre os comandos.
//       // Você também pode forçar a renovação aqui se quiser ter certeza absoluta:
//       // const freshCredentials = await Auth.currentCredentials();
//       // s3Client.config.credentials = freshCredentials;

//       const uploadPartParams = {
//         Bucket: bucket,
//         Key: filename,
//         UploadId: uploadId,
//         PartNumber: partNumber,
//         Body: chunk,
//       };

//       const partResult = await s3Client.send(new UploadPartCommand(uploadPartParams));

//       uploadedParts.push({
//         PartNumber: partNumber,
//         ETag: partResult.ETag,
//       });

//       // Atualiza o progresso
//       const progress = ((i + 1) / totalChunks) * 100;
//       fncProgress(parseFloat(progress.toFixed(2)));
//     }

//     // 5. --- Completar o Upload ---
//     console.log('Completando o Multipart Upload...');
//     const completeParams = {
//       Bucket: bucket,
//       Key: filename,
//       UploadId: uploadId,
//       MultipartUpload: {
//         Parts: uploadedParts,
//       },
//     };

//     await s3Client.send(new CompleteMultipartUploadCommand(completeParams));

//     // 6. --- Retornar o resultado final ---
//     let link = `${fileType === 'film' ? config.S3_MEDIA_FILM.CLOUD_FRONT : config.S3_MUSIC.CLOUD_FRONT}/`;
//     link += filename;

//     console.log('Upload concluído com sucesso!');
//     return { key: filename, filename, link };

//   } catch (error) {
//     console.error('Erro durante o Multipart Upload:', error);

//     // 7. --- Abortar em caso de erro ---
//     if (uploadId) {
//       console.log('Abortando o upload...');
//       await s3Client.send(new AbortMultipartUploadCommand({
//         Bucket: bucket,
//         Key: filename,
//         UploadId: uploadId,
//       }));
//       console.log('Upload abortado.');
//     }

//     throw error;
//   }
// }
